import Outsourcing from "./Outsourcing";

export default Outsourcing;